module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Regular.3f978aca.woff";